<div class="p-grid">
    <div class="p-col-12">

        <p-toast></p-toast>

        <div class="card">
            <p-toolbar styleClass="p-mb-4">
                <ng-template pTemplate="left">
                    <button pButton pRipple label="{{ 'label.novo' | translate }}" icon="pi pi-plus" class="p-button-success p-mr-2 p-mb-2" (click)="openNew()" *ngIf="perfil != null && perfil.nmePerfil === 'ADMTIVIT'"></button>
                </ng-template>

                <ng-template pTemplate="right">
                    <button pButton pRipple label="{{ 'label.exportar' | translate }}" icon="pi pi-upload" class="p-button-help p-mb-2" (click)="downloadFile()"></button>
                </ng-template>
            </p-toolbar>

            <p-table #dt [value]="aplicacoes" [columns]="cols" [rows]="10" [paginator]="true" [globalFilterFields]="['codAplicacao','dscAplicacao','nmeAplicacao','dtaInclusao','staAplicao']"
                     [(selection)]="selectedAplicacoes" [rowHover]="true" dataKey="id"
                     styleClass="p-datatable-customers"
                     currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [showCurrentPageReport]="true">
                <ng-template pTemplate="caption">
                    <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-between table-header">
                        <h5 class="p-m-0">{{ 'aplicacao.titulo' | translate }}</h5>
                        <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')" placeholder="Search..." />
                    </span>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="codAplicacao">{{ 'aplicacao.codigo' | translate }}<p-sortIcon field="codAplicacao"></p-sortIcon></th>
						<th pSortableColumn="dscAplicacao">{{ 'aplicacao.descricao' | translate }} <p-sortIcon field="dscAplicacao"></p-sortIcon></th>
						<th pSortableColumn="nmeAplicacao">{{ 'aplicacao.nome' | translate }} <p-sortIcon field="nmeAplicacao"></p-sortIcon></th>
                        <th></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-aplicacao>
                    <tr>
                        <td><span class="p-column-title" style="text-align: center;">{{ 'aplicacao.codigo' | translate }}</span>
                            {{aplicacao.codAplicacao}}
                        </td>
                        <td><span class="p-column-title" style="text-align: center;">{{ 'aplicacao.descricao' | translate }}</span>
                            {{aplicacao.dscAplicacao}}
												</td>
												<td><span class="p-column-title" style="text-align: center;">{{ 'aplicacao.nome' | translate }}</span>
                            {{aplicacao.nmeAplicacao}}
												</td>
                        <td>
                            <button pButton pRipple icon="pi pi-bookmark" class="p-button-rounded p-button-secondary p-mr-2" (click)="viewAplicacao(aplicacao)"></button>
                            <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-success p-mr-2" (click)="editAplicacao(aplicacao)" *ngIf="perfil != null && perfil.nmePerfil === 'ADMTIVIT'"></button>
                            <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-warning" (click)="deleteAplicacao(aplicacao)" *ngIf="perfil != null && perfil.nmePerfil === 'ADMTIVIT'"></button>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="summary">
                    <div class="p-d-flex p-ai-center p-jc-between">
                       {{ 'label.totalde' | translate }} {{aplicacoes ? aplicacoes.length : 0 }} {{ 'aplicacao.aplicacoes' | translate }}
                    </div>
                </ng-template>
            </p-table>
        </div>

        <p-dialog [(visible)]="aplicacaoDialog" [style]="{width: '450px'}" header="{{ 'aplicacao.detalhes' | translate }}" [modal]="true" styleClass="p-fluid">
            <ng-template pTemplate="content">
                <div class="p-field">
                    <h6>{{ 'empresa.label' | translate }}</h6>
                    <p-pickList [source]="empresaSource" [target]="empresaTarget">
                                <ng-template let-empresa pTemplate="empresas">
                                    <div>
                                        <div style="font-size:14px;float:right;margin:15px 5px 0 0">{{empresa.nmeEmpresa}}</div>
                                    </div>
                                </ng-template>
                    </p-pickList>
                </div>
                 <div class="p-field">
                    <h6>{{ 'label.nome' | translate }}</h6>
                    <input type="text" pInputText id="name" [(ngModel)]="aplicacao.nmeAplicacao" required autofocus />
                </div>
                <div class="p-field">
                    <h6>{{ 'label.descricao' | translate }}</h6>
                    <input type="text" pInputText id="nmePerfil" [(ngModel)]="aplicacao.dscAplicacao" required autofocus/>
                </div>
               
            </ng-template>
            <ng-template pTemplate="footer">
                <button pButton pRipple label="{{ 'label.cancelar' | translate }}" icon="pi pi-times" class="p-button-text" (click)="hideDialog()" ></button>
                <button pButton pRipple label="{{ 'label.salvar' | translate }}" icon="pi pi-check" class="p-button-text" (click)="saveAplicacao()" *ngIf="perfil != null && perfil.nmePerfil === 'ADMTIVIT' && blocked==true"></button>
            </ng-template>
        </p-dialog>

        <p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
    </div>
</div>
